module.exports = __webpack_public_path__ + "img/gex.b1122e4c.png";